import { render, staticRenderFns } from "./SearchImageManage.vue?vue&type=template&id=04dfe5cb&scoped=true"
import script from "./SearchImageManage.vue?vue&type=script&lang=js"
export * from "./SearchImageManage.vue?vue&type=script&lang=js"
import style0 from "./SearchImageManage.vue?vue&type=style&index=0&id=04dfe5cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dfe5cb",
  null
  
)

export default component.exports